import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Offer } from "@/types/airtable";
import { MessageCircle } from "lucide-react";
import { memo } from "react";

interface OfferCardProps {
  offer: Offer;
}

export const OfferCard = memo(function OfferCard({ offer }: OfferCardProps) {
  const handleContact = () => {
    if (offer.contact) {
      if (typeof window !== "undefined" && window.Telegram?.WebApp) {
        window.Telegram.WebApp.HapticFeedback.impactOccurred("light");
        window.Telegram.WebApp.openTelegramLink(offer.contact);
      } else {
        window.open(offer.contact, "_blank");
      }
    }
  };

  return (
    <Card className="overflow-hidden transition-all duration-200 hover:shadow-lg cursor-pointer">
      {offer.image && (
        <div className="aspect-video overflow-hidden">
          <img
            src={offer.image}
            alt={offer.name}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <CardContent className="p-4">
        <div className="space-y-3">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-semibold text-lg leading-tight">
              {offer.name}
            </h3>
            {offer.discount && (
              <div className="flex items-center gap-1 bg-green-100 text-green-800 px-2 py-1 rounded-full text-sm font-medium shrink-0">
                {offer.discount}
              </div>
            )}
          </div>

          {offer.description && (
            <p className="text-muted-foreground text-sm leading-relaxed">
              {offer.description}
            </p>
          )}

          {offer.contact && (
            <Button onClick={handleContact} className="w-full gap-2" size="sm">
              <MessageCircle className="w-4 h-4" />
              Связаться
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
});
